import { Box } from '@mui/material'
import DeadLetterNav from './DeadLetterNav'
import DeadLetterRoutes from './DeadLetterRoutes'

const DeadLetterLayout = () => {
  return (
    <>
      <DeadLetterNav />
      <Box sx={{ px: 3 }}>
        <DeadLetterRoutes />
      </Box>
    </>
  )
}

export default DeadLetterLayout
